export default __webpack_public_path__ + "media/color/bsd-47bfb638.svg";